import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18LikeSBlue = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.secondary.main,
      fillRule: "evenodd",
      d: "M13.118 5.824c1.072 1.1 1.225 2.87.136 4.235-1.068 1.339-3.489 3.459-4.234 3.539a.04.04 0 0 1-.018.001l-.023.001c-.744-.082-3.165-2.202-4.233-3.54-1.09-1.365-.936-3.137.136-4.236a2.695 2.695 0 0 1 3.88 0L9 6.036l.239-.212a2.695 2.695 0 0 1 3.88 0z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18LikeSBlue$1 = Svg18LikeSBlue;

export { Svg18LikeSBlue$1 as default };
